export const STATUS_VARIANTS = {
  ongoing: 'info',
  success: 'success',
  failed: 'danger',
  pending: 'warning'
};
